<template>
  <v-layout row wrap align-center justify-center>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <h1>{{ meta.title }}</h1>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            hide-details
            class="py-0"
          ></v-text-field>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <data-table :search="search"/>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import asyncComponent from '@/utils/asyncComponent';

export default {
  name: 'allWiki',
  data() {
    return {
      search: '',
    };
  },
  computed: {
    meta() {
      return this.$route.meta;
    },
  },
  components: {
    dataTable: asyncComponent({
      component: 'components/data/dataTable',
    }),
  },
};
</script>
